import React from 'react'

import CircularProgress from '@mui/material/CircularProgress'
import styled from 'styled-components'

import { STYLE_CONSTANTS } from 'constants/style'

const Loader = () => {
  return (
    <LoaderWrapper data-testid="loaderWrapper">
      <CircularProgress data-testid="loaderCircular" />
    </LoaderWrapper>
  )
}

const LoaderWrapper = styled.div`
  position: absolute;
  ${STYLE_CONSTANTS.CENTER_ABSOLUTE}
`

export default Loader
